export enum CompanyTypeEnum {
  ccpcAllYear = 'CCPC_ALL_YEAR',
  publicCompany = 'PUBLIC_COMPANY',
  privateCompany = 'PRIVATE_COMPANY',
}
